import { render, staticRenderFns } from "./DocumentModal.vue?vue&type=template&id=cb3c40d8&scoped=true"
import script from "./DocumentModal.vue?vue&type=script&lang=js"
export * from "./DocumentModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentModal.vue?vue&type=style&index=0&id=cb3c40d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3c40d8",
  null
  
)

export default component.exports